import React, { useState, useEffect } from "react";
import FormLogo from "../assets/images/form-logo.png";

const Form = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    college_name: "",
    year_of_student: "",
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
  });

  const [allData, setAllData] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Extract UTM parameters from URL when page loads
  useEffect(() => {
    let source = "";
    let medium = "";
    let campaign = "";

    // Helper function to extract UTM params
    const extract = (params) => {
      if (params.get("utm_source")) source = params.get("utm_source");
      if (params.get("utm_medium")) medium = params.get("utm_medium");
      if (params.get("utm_campaign")) campaign = params.get("utm_campaign");
    };

    // Check standard URL (before the #)
    extract(new URLSearchParams(window.location.search));

    // Check hash URL (after the #)
    if (window.location.hash.includes("?")) {
      const hashQueryString = window.location.hash.split("?")[1];
      extract(new URLSearchParams(hashQueryString));
    }

    // Update form data with UTM parameters
    setFormData((prevData) => ({
      ...prevData,
      utm_source: source,
      utm_medium: medium,
      utm_campaign: campaign,
    }));

    console.log("✅ UTM Parameters detected:", { source, medium, campaign });
  }, []);

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Get the current date and time in IST
      const currentDate = new Date();
      
      // Adjust to Indian Standard Time (UTC+5:30)
      const offsetInMinutes = currentDate.getTimezoneOffset() + 330;
      const currentISTTime = new Date(currentDate.getTime() + offsetInMinutes * 60 * 1000);

      // Format the date and time in 12-hour format with AM/PM
      const options = { 
        year: "numeric", 
        month: "2-digit", 
        day: "2-digit", 
        hour: "2-digit", 
        minute: "2-digit", 
        second: "2-digit", 
        hour12: true
      };
      
      const formattedDateTime = currentISTTime.toLocaleString("en-IN", options);

      // Prepare data to send to SheetDB
      const newData = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        college_name: formData.college_name,
        year_of_student: formData.year_of_student,
        date_and_time: formattedDateTime,
        utm_source: formData.utm_source || "",
        utm_medium: formData.utm_medium || "",
        utm_campaign: formData.utm_campaign || "",
      };

      console.log("📤 Data to be submitted:", newData);

      // Send data to SheetDB
      const response = await fetch('https://sheetdb.io/api/v1/ydgx2yzqvb8em', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newData),
      });

      console.log("📡 Response status:", response.status);

      if (response.ok) {
        const result = await response.json();
        console.log("✅ SUCCESS! Result from SheetDB API:", result);

        // Update local state
        setAllData([...allData, newData]);
        
        // Reset form but keep UTM parameters
        setFormData({
          name: "",
          email: "",
          phone: "",
          college_name: "",
          year_of_student: "",
          utm_source: formData.utm_source,
          utm_medium: formData.utm_medium,
          utm_campaign: formData.utm_campaign,
        });

        // Open Thank You page in new tab
        window.open('/Thankyou', '_blank');

        // Download brochure
        const link = document.createElement('a');
        link.href = '/RoboAi-Brochure.pdf';
        link.download = 'RoboAi-Brochure.pdf';
        link.click();
      } else {
        // Handle API error
        const errorText = await response.text();
        console.error('❌ Failed to save data. Status:', response.status);
        console.error('❌ Error response:', errorText);
      }
    } catch (error) {
      console.error('❌ Network Error:', error);
      console.error('❌ Error details:', error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="overview-form-text">
      <div className="overview-form-top">
        <div className="form-logo">
          <img src={FormLogo} className="form-logo-img" alt="Form Logo" />
        </div>
        <span className="text-want">Want to<br />Download brochure?</span>
      </div>
      <div className="form-overview">
        <div>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <input
              type="tel"
              name="phone"
              placeholder="Phone"
              maxLength={10}
              value={formData.phone}
              onChange={handleChange}
              required
            />
            <input
              type="text"
              name="college_name"
              placeholder="College Name"
              value={formData.college_name}
              onChange={handleChange}
              required
            />

            {/* Dropdown for Year of Student */}
            <select
              name="year_of_student"
              onChange={handleChange}
              value={formData.year_of_student}
              required
            >
              <option value="">Year of Study</option>
              <option value="1st year">1st year</option>
              <option value="2nd year">2nd year</option>
              <option value="3rd year">3rd year</option>
              <option value="4th year">4th year</option>
              <option value="Working professional">Working professional</option>
              <option value="Others">Others</option>
            </select>

            <button type="submit" disabled={isSubmitting}>
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Form;